import { render, staticRenderFns } from "./InventoryViewLabelRules.vue?vue&type=template&id=6ca385fe&"
import script from "./InventoryViewLabelRules.vue?vue&type=script&lang=ts&"
export * from "./InventoryViewLabelRules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports